{
  "w": 9,
  "h": 32,
  "rows": [
    ".YYYYYYY.",
    ".WWWWWWW.",
    "...KwK...",
    "....w....",
    "...cw....",
    "....w....",
    "...Kw....",
    "....w....",
    "...cw....",
    "....w....",
    "...cw....",
    "....w....",
    "...Kw....",
    "....w....",
    "...cw....",
    "....w....",
    "...cw....",
    "....w....",
    "...Kw....",
    "....w....",
    "...cw....",
    "....w....",
    "...cw....",
    "....w....",
    "...Kw....",
    "....w....",
    "...cw....",
    "....w....",
    "...cw....",
    "....w....",
    "....w....",
    "...WWW..."
  ],
  "legend": {
    "K": "C.BLACK",
    "c": "C.CYAN",
    "Y": "C.B_YELLOW",
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
